// @ts-nocheck





import { createSelector } from 'reselect';

import { findOrgUnitInTree } from '../lib/helpers';


export const selectOrgUnits = (state) => state.orgUnits;

export const selectOrgUnit = (orgUnitId) =>
createSelector(selectOrgUnits, (orgUnits) =>
orgUnits ? findOrgUnitInTree(orgUnits, orgUnitId) : null
);

export const selectTrip = (state) => state.trip;
export const selectWialonTrip = (state) =>
state.wialonTrip;
